<template>
	<div class="filter-group">
		<div class="filter-group-header">
			<v-icon :slug="icon" />

			<span :id="label_id" class="label">{{ label }}</span>

			<div class="pill-select">
				<button type="button" :class="{ btn: true, active: is_annual }" @click="set_period(`yr`)">
					Annual
				</button>

				<button type="button" :class="{ btn: true, active: !is_annual }" @click="set_period(`hr`)">
					Hourly
				</button>
			</div>
		</div>

		<fieldset :aria-labelledby="label_id">
			<label v-for="option in options" :key="option.value" class="radio">
				<input v-model.number="radio_value" type="radio" :value="option.value" @change="emit(`change`)" />

				<span>{{ option.label }}</span>
			</label>
		</fieldset>
	</div>
</template>

<style lang="scss" scoped>
@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

@include filter-group;

.pill-select {
	@include pill-select;
	flex: 0 0 auto;
}

fieldset {
	@include filter-chip-list;
}
</style>

<script setup>
import { useId } from 'vue';

import { use_salary_filter } from './_use-salary-filter.js';
import VIcon from './_v-icon.vue';

const label_id = useId();

defineProps({
	icon: {
		type: String,
		required: true,
	},
	label: {
		type: String,
		required: true,
	},
});

const emit = defineEmits([`change`]);

const salary_period = defineModel(`salary_period`, {
	type: String,
	default: ``,
});

const require_salary = defineModel(`require_salary`, {
	type: String,
	default: ``,
});

const salary_min = defineModel(`salary_min`, {
	type: Number,
	default: null,
});

const { is_annual, options, radio_value, set_period } = use_salary_filter(
	salary_period,
	require_salary,
	salary_min,
	emit,
);
</script>
